<template>
  <div>
    <Modal v-model="showModal" title="选择要添加到项目的用户" width="1000" @on-cancel="initSelected">
       <Alert show-icon>重复添加会使该用户角色更新</Alert>
      <Row style="width: 50%;display: inline-block;">
      <Select v-model="selectedUser" multiple filterable @on-change="memSelChange" placeholder="选择用户" >
        <Option v-for="(item, index) in userList" :key="index" :value="item">
           {{ item }}
        </Option>
      </Select>
      </Row>
      <Row style="width: 50%;display: inline-block;padding-left: 1%;">
        <Select v-model="selectedRole" placeholder="选择角色：" style="width: 73%;display: inline-block;margin-right: 1%;">
        <Option v-for="item in roleList" :key="item.id" :value="item.id">
          {{ item.dec }}
        </Option>
      </Select>
       <Button type="success"  @click="addProjectMember()" :disabled="disabledAddMember" style="width: 25%;display: inline-block;">添加到项目</Button>
      </Row>
      <Divider />
      <Divider />
      <div>
        <Form :model="memberSearchForm" ref="memberSearchForm" inline :label-width="40" @submit.native.prevent>
          <FormItem label="筛选">
            <Input v-model="memberSearchForm.name" style="width: 200px" placeholder="成员名称" @keyup.enter.native="getProjectMemberList()" />
          </FormItem>
          <FormItem :label-width="0" class="mob-align-right">
            <Button type="primary" @click="getProjectMemberList()">搜索</Button>
          </FormItem>
        </Form>
        <Table
          stripe
          border
          highlight-row
          ref="ProjectMemberTable"
          :data="members.data"
          :loading="tableLoading"
          :columns="members.columns"></Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: left;">
            当前显示 {{ members.data.length }} 条记录，总共 {{ members.count }} 条记录
          </div>
          <div style="float: right;">
            <page
              :total="members.count"
              :current="members.page"
              :page-size="members.size"
              @on-change="getProjectMemberList"></page>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getAllUsers, getProjectUsers, addProjectMember, deleteProjectMember } from '@/api/tools/svn'
export default {
  name: 'ProjectMember',
  props: ['projectId', 'node'],
  data () {
    return {
      tableLoading: false,
      disabledAddMember: true,
      memberSearchForm: {
        name: ''
      },
      roleList: [
        { id: 0, name: 'No Access', dec: '无权限' },
        { id: 1, name: 'Read Only', dec: '只读' },
        { id: 2, name: 'Read Write', dec: '可读可写' }
      ],
      selectedUser: [],
      selectedRole: null,
      showModal: false,
      userList: [],
      members: {
        data: [],
        columns: [
          {
            title: '成员名称',
            key: 'name',
            align: 'center',
            tooltip: true,
            minWidth: 200
          },
          {
            title: '成员角色',
            key: 'permission',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              return h('span', params.row.permission ? this.roleList.filter(item => item.id === parseInt(params.row.permission))[0].dec : '')
            }
          }
          // {
          //   title: '操作',
          //   align: 'center',
          //   fixed: 'right',
          //   width: 200,
          //   render: (h, params) => {
          //     return h('div', [
          //       h('Poptip', {
          //         props: {
          //           confirm: true,
          //           transfer: true,
          //           placement: 'bottom',
          //           title: '你确定要删除吗?'
          //         },
          //         style: {
          //           display: this.$store.state.user.superuser && parseInt(params.row.access_level) !== 50 ? 'inline-block' : 'none'
          //         },
          //         on: {
          //           'on-ok': () => {
          //             this.delete(params.row)
          //           }
          //         }
          //       }, [
          //         h('Button', {
          //           props: {
          //             type: 'error',
          //             size: 'small'
          //           }
          //         }, '删除')
          //       ])
          //     ])
          //   }
          // }
        ],
        count: 0,
        page: 1,
        size: 5
      }
    }
  },
  watch: {
    projectId () {
      this.getProjectMemberList()
    },
    node () {
      this.getUserList()
    }
  },
  methods: {
    delete (row) {
      let data = {
        userId: row.id,
        projectId: this.projectId,
        node: this.node
      }
      deleteProjectMember(data).then(res => {
        if (res.data.code === 200) {
          this.getProjectMemberList()
        } else {
          this.$Message.error('删除项目成员失败')
        }
      }).catch(res => {
        this.changeLoadingShow = false
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    initSelected () {
      this.selectedUser = []
      this.selectedRole = null
      this.memberSearchForm.name = ''
    },
    addProjectMember () {
      if (this.selectedRole !== null && this.selectedUser.length) {
        let data = {
          userId: this.selectedUser,
          role: this.selectedRole,
          projectId: this.projectId,
          node: this.node
        }
        addProjectMember(data).then(res => {
          if (res.data.code === 200) {
            this.disabledAddMember = true
            this.initSelected()
            this.getProjectMemberList()
          } else {
            this.$Message.error('添加成员到项目失败')
          }
        }).catch(res => {
          this.changeLoadingShow = false
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({ title: '请选择用户和角色' })
      }
    },
    memSelChange () {
      this.disabledAddMember = false
    },
    // 打开选择对话框
    openModal () {
      if (this.projectId) {
        this.getProjectMemberList()
      }
      if (this.node) {
        this.getUserList()
      }
      this.showModal = true
    },
    // 获取所有svn用户列表
    getUserList () {
      let params = {
        node: this.node
      }
      getAllUsers(params).then(res => {
        this.userList = res.data
      }).catch(res => {
        console.log(res.response)
      })
    },
    // 获取项目用户列表
    getProjectMemberList (value = 1) {
      this.members.data = []
      this.tableLoading = true
      this.members.page = value
      let params = {
        project_id: this.projectId,
        node: this.node,
        name: this.memberSearchForm.name,
        size: this.members.size,
        page: this.members.page
      }
      getProjectUsers(params).then(res => {
        this.members.data = res.data.results
        this.members.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        console.log(res.response)
        this.tableLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
